import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SpecialistForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { AdminForgotPasswordComponent } from './components/admin-forgot-password/admin-forgot-password.component';
import { AdminSignInComponent } from './components/admin-sign-in/admin-sign-in.component';
import { PcvForgotPasswordComponent } from './components/pcv-forgot-password/pcv-forgot-password.component';
import { PcvSignInComponent } from './components/pcv-sign-in/pcv-sign-in.component';
import { PcvSignUpComponent } from './components/pcv-sign-up/pcv-sign-up.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { SpecialistSignInComponent } from './components/sign-in/sign-in.component';
import { SpecialistSignUpComponent } from './components/sign-up/sign-up.component';
import { AdminChangeEmailComponent } from './components/admin-change-email/admin-change-email.component';
import { SetupAccountComponent } from './components/setup-account/setup-account.component';
import { AuthCallbackComponent } from './components/auth-callback/auth-callback.component';
import { AutoSsoComponent } from './components/auto-sso/auto-sso.component';
import { environment } from 'src/environments/environment';

// Determine default auth route based on specialty intake feature flag
const defaultAuthRoute = environment.features.specialtyIntakeEnabled ? 'auto-sso' : 'specialist-sign-in';

const routes: Routes = [
  {path: "",redirectTo: defaultAuthRoute, pathMatch: "full"},
  {path: "specialist-signup",component: SpecialistSignUpComponent},
  {path: "specialist-signup/:token",component: SpecialistSignUpComponent},
  {path: "specialist-signin",component: SpecialistSignInComponent},
  {path: "specialist-forgot-password",component: SpecialistForgotPasswordComponent},
  {path: "reset-password/:token/:userType",component: ResetPasswordComponent},
  {path: "pcv-signup",component: PcvSignUpComponent},
  {path: "pcv-signup/:token",component: PcvSignUpComponent},
  {path: "pcv-signin",component: PcvSignInComponent},
  {path: "pcv-forgot-password",component: PcvForgotPasswordComponent} ,
  {path: "admin-signup/:token",component: SpecialistSignUpComponent},
  {path: "admin-signin",component: AdminSignInComponent},
  {path: "admin-forgot-password",component: AdminForgotPasswordComponent},
  {path: "admin/verifyEmail/:token",component: AdminChangeEmailComponent},
  {path: "setup",component: SetupAccountComponent},
  {path: "auth-callback",component: AuthCallbackComponent},
  {path: "auto-sso",component: AutoSsoComponent}

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthenticationRoutingModule { }
